import React from 'react';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import {Navigate} from 'react-router-dom';
import {toast} from 'react-toastify';
import {Role} from '../../incase-domain/user';
import {useLoggedInUser} from '../../ui/pages/auth/queries';
import {isLoggedInSelector, loggedInUserSelector} from '../../store/selectors/auth.selectors';

export function ProtectedRoute({roles, children}: {roles: Role[]; children: JSX.Element}): JSX.Element {
    const user = useSelector(loggedInUserSelector);
    const isLoggedIn = useSelector(isLoggedInSelector);
    const {t} = useTranslation();
    const {isFetched} = useLoggedInUser();

    if (!user && isFetched) {
        return <Navigate to="/login" replace />;
    }

    if (isLoggedIn) {
        if (user && roles && !roles?.some((role) => user.roles?.includes(role))) {
            toast.error(t('common.permissionDenied'));

            return <Navigate to="/" replace />;
        }
        return children;
    }

    return <div />;
}
